import React, { memo } from "react";
import { Box, Typography } from "@mui/material";
import { valueFormat } from "src/helper/valueFormat";
import { convertPaymentMethod } from "src/utils/paymentUtils";
import {formatDateByTimeZone, filterRefundsTransaction, STATUS_NAME} from "src/utils";


const collectTransactionsDto = (transactions) => {
  const filtered = filterRefundsTransaction(transactions);

  return filtered.map((item, { paymentInfo: p = {} }) => {
    const { emvTagData } = p;

    const tagData = emvTagData || null;
    const authCode = p.authcode  || '';

    let aid = '';
    let card_reader = '';

    if (tagData) {
      try {
        const emvData = JSON.parse(tagData);
        aid = emvData?.AID || '';
        card_reader = emvData?.['Entry method'] || '';
      } catch (err) {
        console.error('Failed to parse emvTagData:', err);
      }
    }

    const retRef = p?.retRef || p?.retref || '';
    return {
      changed:        item?.paymentInfo?.changed || p?.changed || item?.changed || null,
      amount:        item?.paymentInfo?.tendered || item?.tendered || p?.tendered || null,
      tender:        convertPaymentMethod(item?.tender?.method) || '',
      card_type:     item?.paymentInfo?.cardType || p?.cardType || '',
      account:       item?.paymentInfo?.lastFour || p?.lastFour ?
        `XXXX XXXX XXXX ${item?.paymentInfo?.lastFour || p?.lastFour || ''}` : null,
      capture:       item?.paymentInfo?.capture || p?.capture || '',
      pin:           item?.paymentInfo?.pin || p?.pin || '',
      authCode:      authCode || item?.paymentInfo?.authCode || '',
      retRef:        item?.paymentInfo?.retRef || retRef || '',
      terminalId:    item?.paymentInfo?.terminalId || p?.terminalId || '',
      transactionId: item?.paymentInfo?.transactionId || p?.transactionId || '',
      aid:           aid || item?.paymentInfo?.aid || '',
      card_reader:   card_reader || item?.paymentInfo?.card_reader || '',
      createdAt:     item?.createdAt || null,
      isFailed:      item?.status?.name === STATUS_NAME.FAIL,
    };
  });
};

const RefundTransactions = ({ orderData }) => {
  const transactions = collectTransactionsDto(orderData?.metadata?.transactions);
  const timeZoneId = orderData?.metadata?.business?.timezone?.timeZoneId;

  return (
    <>
      {transactions?.map((transaction, index) => {
        return (
          <React.Fragment key={`tr-${index}-refund`}>
            <Box className="payment-container">
              <Box style={{ width: "100%" }}>

                <Box style={{ marginBottom: '16px' }}>
                  <Box className="payment-container-flex">
                    <Typography className="payment-title uppercase" style={{ fontWeight: 600, fontSize: 20 }}>
                      {transaction?.isFailed ? 'Refund declined:' : 'Refund:'}
                    </Typography>
                    <Typography className="payment-title" style={{ fontWeight: 600, fontSize: 20 }}>
                      {valueFormat(`($${Number(transaction?.amount || 0).toFixed(2)})`)}
                    </Typography>
                  </Box>
                  {transaction?.createdAt && (
                    <Box className="payment-container-flex" style={{ marginTop: '12px' }}>
                      <Typography className="payment-title uppercase">
                        Refund Date:
                      </Typography>
                      <Typography className="payment-title">
                        {formatDateByTimeZone(transaction?.createdAt, timeZoneId)}
                      </Typography>
                    </Box>
                  )}
                  {transaction?.amount && (
                    <Box className="payment-container-flex">
                      <Typography className="payment-title uppercase">
                        Refund Amount:
                      </Typography>
                      <Typography className="payment-title">
                        {valueFormat(`($${Number(transaction?.amount || 0).toFixed(2)})`)}
                      </Typography>
                    </Box>
                  )}
                </Box>

                {transaction?.card_type && (
                  <Box className="delivery-wrapper" style={{ marginTop: '12px' }}>
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Card Type:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.card_type}
                    </Typography>
                  </Box>
                )}
                {transaction?.account && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Account:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.account}
                    </Typography>
                  </Box>
                )}
                {transaction?.capture && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Capture:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.capture}
                    </Typography>
                  </Box>
                )}

                {transaction?.pin && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Pin:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.pin}
                    </Typography>
                  </Box>
                )}
                {transaction?.authCode && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Auth code:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.authCode}
                    </Typography>
                  </Box>
                )}

                {transaction?.retRef && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Auth ref:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.retRef}
                    </Typography>
                  </Box>
                )}

                {transaction?.terminalId && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Terminal Id:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.terminalId}
                    </Typography>
                  </Box>
                )}

                {transaction?.transactionId && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      Trans #:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.transactionId}
                    </Typography>
                  </Box>
                )}

                {transaction?.aid && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      aid:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.aid}
                    </Typography>
                  </Box>
                )}

                {transaction?.card_reader && (
                  <Box className="delivery-wrapper">
                    <Typography className="payment-title uppercase payment-wrapper-left">
                      card reader:
                    </Typography>
                    <Typography className="payment-title payment-wrapper-right uppercase">
                      {transaction?.card_reader}
                    </Typography>
                  </Box>
                )}

              </Box>
            </Box>
            <hr className="line-header"/>
          </React.Fragment>
        )
      })}
    </>
  )
}
export default memo(RefundTransactions)